export default __webpack_public_path__ + "static/media/brac1.eb3f76e5.jpg";